<template>
  <div class="chips">
    <button
      v-for="opt in normalized"
      :key="opt.value"
      class="chip"
      :class="{ active: modelValue === opt.value }"
      @click="$emit('update:modelValue', opt.value)"
    >
      {{ opt.label }}<span v-if="opt.count != null" class="chip-count">{{ opt.count }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'FilterChips',
  props: {
    // options: string[] OR [{ value, label, count? }]
    options: { type: Array, required: true },
    modelValue: { type: [String, Number], default: '' }
  },
  emits: ['update:modelValue'],
  computed: {
    normalized() {
      return this.options.map(o =>
        (typeof o === 'object' && o !== null)
          ? { value: o.value, label: o.label ?? String(o.value), count: o.count }
          : { value: o, label: String(o), count: null }
      )
    }
  }
}
</script>

<style scoped>
.chips { display: flex; gap: 6px; flex-wrap: wrap; }
.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: var(--field-bg);
  border: 1px solid var(--panel-border);
  border-radius: 16px;
  color: var(--text-secondary);
  font-size: 12.5px;
  cursor: pointer;
  transition: color 0.18s ease, background 0.18s ease, border-color 0.18s ease;
}
.chip:hover { color: var(--text-primary); }
.chip.active {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: #fff;
}
.chip-count {
  font-size: 11px;
  padding: 0 6px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.14);
  color: inherit;
}
.chip:not(.active) .chip-count { background: rgba(255, 255, 255, 0.08); }
</style>
